import { createSelector } from "reselect"
import { iCurrentUser, ReduxState } from "../common/types"
import { startOfTheWeekSelector } from "../filters/selectors"

export const userSelector = (state: ReduxState): iCurrentUser => state.current_user

export const startOfWeekIndexSelector = createSelector(userSelector, user => startOfTheWeekSelector(user))
